import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findFlagUrlByIso3Code } from "country-flags-svg";

import { translateStaticContent } from '../../../helpers/translateStaticContent';

class PartnerItem extends Component {
    constructor(props) {
        super(props);
    }

    handleClick = (e) => {
       if (e.currentTarget.attributes.href.nodeValue === '#') {
           e.preventDefault();
       }
    }

    setPartnerName = (e) => {
       e.target.style.display = 'none';
       e.target.nextElementSibling.classList.add('show');
    }

    render() {
        const {countryName, list, countryIso3} = this.props.data
        const flagUrl = findFlagUrlByIso3Code(countryIso3);
        return(
            <div className="container partnerItem">
                <div className="state">
                     <span className="state-logo">
                         <img src={flagUrl} alt={countryName} referrerPolicy="no-referrer"/>
                     </span>
                     <span className="state-name">{countryName}</span>
                </div>
                <div className="partners-List">
                    {list.map(item => {
                        let websiteLink = '';
                        let target = '';
                        let rel = '';
                        const isHtts = item.websiteLink.indexOf('http');
                        if (isHtts === -1 && item.isActive) {
                            websiteLink = 'https://' + item.websiteLink;
                            target = '_blank';
                            rel = 'noreferrer';
                        } else if (item.isActive) {
                            websiteLink = item.websiteLink;
                            target = '_blank';
                            rel = 'noreferrer';
                        } else if (!item.isActive) {
                            websiteLink = '#'
                        }
                        return  <span className={`${item.isActive ? '' : 'disabled'}`} key={item.id}>
                                    <a href={websiteLink} target={target} rel={rel} onClick={this.handleClick}>
                                        <span className='partner-item'>
                                            <img onError={this.setPartnerName} referrerPolicy="no-referrer"
                                                 src={`/api/welsend/public/partners/${item.id}/logo`} 
                                                 className="partner-logo"/>
                                             <span className="parnterName">{item.name}</span>
                                        </span>
                                    </a>
                                    <span className="not-available">
                                        {translateStaticContent('partnersWarningMessage', 
                                            this.props.defaultStaticContentPartners, 
                                            this.props.activeLangStaticContentPartners)}
                                    </span>
                                    <span className='comment'>
                                        <span dangerouslySetInnerHTML={createMarkupComment(item.partnerLangDetailDtos ? 
                                        item.partnerLangDetailDtos[0].unavailabilityComment : '')}/>
                                    </span>
                                </span>
                    })}
                </div>
            </div>
        )
    }
    
}

export default PartnerItem;

const createMarkupComment = (comment) => {
    return {__html: comment};
}

PartnerItem.propTypes = {
    data: PropTypes.shape({
        list: PropTypes.array.isRequired,
        countryName: PropTypes.string,
        countryIso3: PropTypes.string,
        unavailabilityComment: PropTypes.string,
        isActive: PropTypes.bool,
    }),
    defaultStaticContentPartners: PropTypes.object,
    activeLangStaticContentPartners: PropTypes.object,
}